<script setup>
import { useHttp } from "vutil";
import { reactive } from "vue";

const emit = defineEmits(["login"]);

const data = reactive({ email: null, passwd: null });

const { busy, error, post } = useHttp(() => emit("login"));
</script>

<template>
	<h1>Logg inn</h1>
	<form @submit.prevent="post('/api/user/login', data)">
		<fieldset :disabled="busy">
			<label for="email">E-postadresse</label>
			<input id="email" v-model.trim="data.email" type="email" autocomplete="username" autofocus required>
			<label for="password">Passord</label>
			<input id="passwd" v-model="data.passwd" type="password" autocomplete="current-password" required>
			<div class="error">{{ error }}</div>
			<button type="submit" class="ui">Logg inn</button>
		</fieldset>
	</form>
</template>
